/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useCWPContext from '../context/useCWPContext';

function Table() {
  //
  const {
    activeTab,
    cwpData,
    loading,
    rowsSelected,
    setRowsSelected,
    handleUpdateAll,
    handleViewAppointments,
    handleViewCalendar,
  } = useContext(useCWPContext);

  const [sortModel, setSortModel] = useState([
    {
      field: 'date_scheduled',
      sort: 'desc',
    },
  ]);

  const statusColumn =
    activeTab === 0
      ? []
      : [
          {
            field: 'date_approved',
            flex: 1,
            headerName: activeTab === 1 ? 'Approved Date' : 'Rejected Date',
            width: 200,
          },
        ];
  const columns = [
    {
      field: 'rep_name',
      flex: 1,
      headerName: 'Name',
      width: 200,
      renderCell: ({ row }) => (
        <div>
          {activeTab === 0 ? (
            <div>
              <Button variant='text' onClick={() => handleViewCalendar(row)}>
                {row.rep_name}
              </Button>
            </div>
          ) : (
            row.rep_name
          )}
        </div>
      ),
    },
    { field: 'point_person_name', flex: 1, headerName: 'Point Person(s)', width: 200 },
    { field: 'appointment_date', flex: 1, headerName: 'Appointment', width: 200 },
    { field: 'date_submitted', flex: 1, headerName: 'Submission Date(s)', width: 200 },
    ...statusColumn,
    {
      field: 'action',
      flex: 1,
      headerName: 'Action',
      width: 200,
      renderCell: ({ row }) => (
        <div>
          <Button
            size='small'
            variant='contained'
            color='primary'
            onClick={(e) => handleViewAppointments(row?.appointment_id)}
          >
            View Details
          </Button>
        </div>
      ),
    },
  ];
  return (
    <Grid container spacing={2}>
      {activeTab === 0 ? (
        <Grid xs={12} sm={12} md={12}>
          {rowsSelected.length > 0 ? (
            <Button
              size='small'
              variant='contained'
              color='success'
              sx={{ float: 'right' }}
              onClick={(e) => handleUpdateAll(1, true)}
              startIcon={<CheckIcon />}
            >
              Approve All Selected
            </Button>
          ) : (
            ''
          )}
        </Grid>
      ) : (
        ''
      )}

      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          &nbsp;
          <DataGridPro
            rows={cwpData}
            columns={columns}
            loading={loading}
            sortModel={sortModel}
            disableSelectionOnClick
            checkboxSelection={activeTab === 0}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = cwpData.filter((row) => selectedIDs.has(row.id));

              setRowsSelected(selectedRows);
            }}
            initialState={{
              ...cwpData.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            pageSizeOptions={[25, 50, 75, 100]}
            pagination
            onSortModelChange={(model) => setSortModel(model)}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default Table;
